import './Header.scss';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/Logo-Accolade-dark-2.png';
import languageIcon from '../../assets/icons/language-icon.svg';
import externalLinkIcon from '../../assets/icons/external-link-icon.svg';
import UserMenu from '../UserMenu/UserMenu';

export const Header = () => {
  const { t, i18n } = useTranslation('common');
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/auth" replace />;
  }
  const isActive = (path: string) => location.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : '';
  };
  
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    document.body.style.overflow = '';
  };

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <header className="header">
      <div className="header__content">
        <Link to="/home" className="header__logo">
          <img src={logo} alt="Accolade Logo" />
        </Link>

        <nav className="header__nav">
          <Link
            to="/home"
            className={`header__nav-link ${isActive('/home') ? 'active' : ''}`}
          >
            {t('nav.home')}
          </Link>
          <Link
            to="/resources"
            className={`header__nav-link ${isActive('/resources') ? 'active' : ''}`}
          >
            {t('nav.resources')}
          </Link>
          <a
            href="https://subzero.csod.com/login/render.aspx?id=defaultclp&CLP=false"
            className="header__nav-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('nav.trainings')}
            <img src={externalLinkIcon} alt="" className="header__external-link-icon" />
          </a>
          <Link
            to="/appointment"
            className={`header__nav-link ${isActive('/appointment') ? 'active' : ''}`}
          >
            {t('nav.appointment')}
          </Link>
          <Link
            to="/events"
            className={`header__nav-link ${isActive('/events') ? 'active' : ''}`}
          >
            {t('nav.events')}
          </Link>
          <Link
            to="/contact"
            className={`header__nav-link ${isActive('/contact') ? 'active' : ''}`}
          >
            {t('nav.contact')}
          </Link>
        </nav>

        <div className="header__actions">
          <button
            className="header__action-button header__language-selector"
            onClick={toggleLanguage}
            aria-label={t('nav.changeLanguage')}
          >
            <img src={languageIcon} alt="" />
            <span>{i18n.language.toUpperCase()}</span>
          </button>
          <UserMenu />
        </div>

        <button 
          className={`header__mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label={t('nav.menu')}
          aria-expanded={isMobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`header__mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
          <nav className="header__mobile-nav-content">
            <Link
              to="/home"
              className={`header__mobile-nav-link ${isActive('/home') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              {t('nav.home')}
            </Link>
            <Link
              to="/resources"
              className={`header__mobile-nav-link ${isActive('/resources') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              {t('nav.resources')}
            </Link>
            <a
              href="https://subzero.csod.com/login/render.aspx?id=defaultclp&CLP=false"
              className="header__mobile-nav-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMobileMenu}
            >
              {t('nav.trainings')}
              <img src={externalLinkIcon} alt="" className="header__external-link-icon" />
            </a>
            <Link
              to="/appointment"
              className={`header__mobile-nav-link ${isActive('/appointment') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              {t('nav.appointment')}
            </Link>
            <Link
              to="/events"
              className={`header__mobile-nav-link ${isActive('/events') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              {t('nav.events')}
            </Link>
            <Link
              to="/contact"
              className={`header__mobile-nav-link ${isActive('/contact') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              {t('nav.contact')}
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};
